import { call, takeLatest } from 'redux-saga/effects';

import { fetchOrderList, resource, getError } from 'modules/api';
import { GET_ORDERS } from 'modules/dashboard/store/constants';

import { getOrdersPayload } from './utils';

function* onGetOrders() {
  try {
    const request = resource(GET_ORDERS, fetchOrderList, getOrdersPayload);
    const payload = yield call(request);

    return payload;
  } catch (error) {
    const payload = getError(error);
    // eslint-disable-next-line no-console
    console.error(payload);
    return payload;
  }
}

export function* watchGetOrders() {
  yield takeLatest(GET_ORDERS, onGetOrders);
}
